import {IMenuStructureItem, generateRoute} from 'store/slices/menu-slice';

interface IFindAllParentsIdsArgs {
    menuStructure: IMenuStructureItem[] | undefined | null;
    current: IMenuStructureItem;
    includeCurrentItem?: boolean;
}
export const findAllParentsIds = ({
    menuStructure,
    current,
    includeCurrentItem,
}: IFindAllParentsIdsArgs): string[] => {
    if (!menuStructure) return [];

    const parents: string[] = [];

    if (includeCurrentItem) {
        parents.push(current.id);
    }

    while (current?.parentId) {
        // eslint-disable-next-line no-loop-func
        const parent = menuStructure.find(mItem => mItem.id === current?.parentId);
        if (!parent) break;
        parents.push(parent.id);
        current = parent;
    }

    return parents.reverse(); // Чтобы корневой элемент был первым
};

interface ICheckIfIsTopLevelMenuItemSelectedArgs {
    menuStructure: IMenuStructureItem[] | null;
    pathname: string;
    item: IMenuStructureItem | undefined;
}
export const checkIfIsTopLevelMenuItemSelected = ({
    item,
    menuStructure,
    pathname,
}: ICheckIfIsTopLevelMenuItemSelectedArgs) => {
    const childEntityName = pathname.substring(1).split('/');
    const currentItem = menuStructure?.find(it => pathname === generateRoute({
        ...it,
        childEntityName: childEntityName[1],
    }));
    if (!currentItem) return false;
    if (!item) return false;
    const parentsIds = findAllParentsIds({
        menuStructure,
        current: currentItem,
        includeCurrentItem: true,
    });
    return parentsIds?.includes(item?.id);
};

const normalizePathnameForMenu = (path: string): string => path.replace(/^\/table-reports/, '');

interface IGetSelectedMenusIdsByPathnameArgs {
    menuStructure: IMenuStructureItem[] | undefined;
    pathname: string;
}

export const getSelectedMenusIdsByPathname = ({
    menuStructure,
    pathname,
}: IGetSelectedMenusIdsByPathnameArgs): string[] => {
    if (!menuStructure?.length) {
        return [];
    }

    const pathnameEntityName = normalizePathnameForMenu(pathname).split('/')[1];

    const currentMenu = pathname.startsWith('/table-reports/')
        ? menuStructure.find(m => m.templateCode === pathnameEntityName)
        : menuStructure.find(m => m.entityName === pathnameEntityName);

    if (!currentMenu) {
        return [];
    }

    const parentsIds = findAllParentsIds({
        menuStructure,
        current: currentMenu,
    });

    return parentsIds;
};
